import type { MailboxInfo } from "owa-client-types";
import { isAccountFeatureEnabled } from "owa-feature-flags";

export function isMyOutlookProductEnabled(mailboxInfo: MailboxInfo): boolean {
    return isAccountFeatureEnabled("acct-personalos-augloop", mailboxInfo);
}
